module.exports = __webpack_public_path__ + "7af6f8c96c4d5318575915053890fed9.png";